import template from './sw-cms-element-manufacturer-preview.html.twig';
import './sw-cms-element-manufacturer-preview.scss';

const { Component } = Shopware;

Component.register('sw-cms-element-manufacturer-preview', {
    template
});
